// Top HUD layout by window width (web desktop and browser zoom; Sol fonts-accept Q2, 2026-10-06).
//  - 'wide': the coins / lesson / plan / store group is centred and Exit sits on the right edge (the original layout).
//  - 'compact': the group moves right, beside Exit, and the plan chip shortens to "Upgrade", so the lesson panel on the
//    left keeps at least LESSON_PANEL_MIN of width.
//  - 'stacked': too narrow for the panel beside the group: the group wraps into rows next to Exit across the full width
//    and the lesson panel moves below the HUD.
// The thresholds come from the group's widths on the type scale (coins ~90, lesson pill ~130, full plan chip ~300 or
// "Upgrade" ~110, store 40, gaps and padding ~60) plus Exit Lesson (~130) and the panel's minimum.

export const HUD_WIDE_MIN = 1200;
export const HUD_COMPACT_MIN = 880;
export const LESSON_PANEL_MIN = 240;

export function hudMode(windowWidth) {
  if (windowWidth >= HUD_WIDE_MIN) return 'wide';
  if (windowWidth >= HUD_COMPACT_MIN) return 'compact';
  return 'stacked';
}
